module.exports = __webpack_public_path__ + "static/media/live-top-mob-img.e4b9e5fe.png";